const endPoints = {
    auth: {
        sendCodeOTP: 'authentication/enviar2faNomina',
        validCodeOTP: 'authentication/validar2faNomina',
        getCompanias: 'authentication/obtenerCompaniasUsuario',
        getTokenKeycloack: 'authentication/obtenerTokenKeycloak',
    },
    terms: {
        base: 'firma/guardarversionpolitica',
        getTermsVersion: 'firma/versionpolitica',
        getTermsPDF: 'empresas/documento-politica-datos',
    },
    pdfViewer: {
        base: 'firma',
        status: 'firma/estado',
        validate: 'firma/validar',
        apiAnnotation: 'https://firmaelectronica.heinsohn.com.co/merge/api/signDocument',
        geoBase: 'https://www.cloudflare.com/cdn-cgi/trace',
        geoAltern: 'https://api.ipify.org/?format=json',
    },
};

export default endPoints;
